import { inject, observer } from 'mobx-react';
import ColumnWaterfall from 'components/GalleryList/ColumnWaterfall';



const Column2 = (props: any)=>{
  return <ColumnWaterfall {...props} />
}


/**
 * 2025年03月20日17:13:43
 *
 * 观察后发现和 src/components/GalleryList/ColumnWaterfall.tsx => ColumnWaterfall 一模一样
 */
export default inject('rootStore')(observer(Column2));
